import {IOrganization} from './organization.model';

export interface IConnector {
  id?: number;
  itemName?: string;
  status?: string;
  description?: string;
  organization?: IOrganization;
  lastModifiedDate?: any;
  createdDate?: any;

}

export class Connector implements IConnector {
  constructor(public id?: number, public itemName?: string, public status?: string, public description?: string
    , public organization?: IOrganization,
              public lastModifiedDate?: any,
              public createdDate?: any,) {
  }
}
